import { ConvenienceTest } from '@repo/user-types'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getConvenienceTests = async ({
  api,
  config,
}: {
  api: AxiosInstance
  params?: void
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<ConvenienceTest[]>> => {
  return api.get<ConvenienceTest[]>('/user/me/convenience-tests', config)
}
